import React, { useState } from 'react';
import Swatch from '@ynap/swatch';
import BEMHelper from '@ynap/bem-helper';
import { Link } from 'react-router-dom';
import { productSelectors } from '@ynap/product-state';

const bem = new BEMHelper('Colours');

const MAX_COLOURS = 5;
const MIN_COLOURS = 1;

const Colours = (props) => {
    const [hoveredColour, setHoveredColour] = useState(0);
    const { className, colours, loading = false, Wrapper = 'div', product, features, setColourImagePartNumber, pdpUrlTemplate, locale } = props;
    if (features?.hideColour) return null;
    if (loading) {
        return <div className={bem(null, 'loading', className)} />;
    }

    const selectedColour = colours?.find((c) => product?.partNumber === c.partNumber);
    const orderedColours = colours?.filter((c) => product?.partNumber !== c.partNumber && c.buyable) || [];
    if (selectedColour) orderedColours.unshift(selectedColour);
    const collapseColours = orderedColours?.length > MAX_COLOURS;
    const showSwatches = orderedColours?.length > MIN_COLOURS;
    const { getProductLinkByPartNumber } = productSelectors;

    if (!showSwatches) return null;

    const handleMouseEnter = (partNumber, index) => {
        setColourImagePartNumber(partNumber);
        setHoveredColour(index);
    };

    const handleMouseLeave = () => {
        setColourImagePartNumber(null);
        setHoveredColour(0);
    };

    return (
        <div className={bem('coloursList')}>
            <ul className={bem('swatchList', { collapseColours })} onMouseLeave={handleMouseLeave}>
                {orderedColours.map((colour, index) => {
                    const { href, partNumber, swatch, buyable, label, seo } = colour;
                    const active = product?.partNumber === partNumber;
                    const productUrl = getProductLinkByPartNumber(pdpUrlTemplate, locale, seo, partNumber);

                    return (
                        <li className={bem('swatch')} onMouseEnter={() => handleMouseEnter(partNumber, index)} key={partNumber}>
                            <Link to={productUrl} aria-label={`colour ${label}`} aria-current={active ? "true" : "false"}>
                                <Wrapper selected={active} productUrl={href} partNumber={partNumber} title={label} position={index + 1}>
                                    <Swatch
                                        colour={swatch?.HEX}
                                        url={swatch?.url?.replace('{width}', '50')}
                                        notBuyable={!buyable}
                                        colourClass={bem('swatchImage')}
                                        className={bem('swatchImageWrapper', {
                                            hovered: hoveredColour === index,
                                        })}
                                    />
                                </Wrapper>
                            </Link>
                        </li>
                    );
                })}
            </ul>
            {collapseColours && (
                <Link to={product ? product.href : ''} className={bem('moreColours')}>
                    +
                </Link>
            )}
        </div>
    );
};

export default Colours;
